import { SectionStatus } from './types';
import { getSectionLabel, getStatusBadgeClasses } from './statusUtils';

interface SectionStatusBadgeProps {
  /** Draft being filled in vs. submitted — see getSectionLabel */
  isFillingIn: boolean;
  status: SectionStatus;
  unresolvedCount: number;
  totalClarificationCount: number;
}

export const SectionStatusBadge = ({
  isFillingIn,
  status,
  unresolvedCount,
  totalClarificationCount,
}: SectionStatusBadgeProps) => {
  const label = getSectionLabel({
    isFillingIn,
    status,
    unresolvedCount,
    totalClarificationCount,
  });
  if (!label) return null;

  return (
    <span className={getStatusBadgeClasses(label.tone)}>{label.text}</span>
  );
};
